import React from 'react'
import Routes from './route'
function App() {
  return (
   <Routes></Routes>
  );
}

export default App;